<template>
  <el-dialog
    title="询价"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="demo-ruleForm"
    >
      <el-divider content-position="left">询价信息</el-divider>
      <el-table :data="ruleForm.tableData" border style="width: 100%">
        <el-table-column prop="title" label="服务名称" align="center"> </el-table-column>
        <el-table-column prop="money" label="服务定价" width="100" align="center">
        </el-table-column>
        <el-table-column prop="type" label="服务类型" align="center"> </el-table-column>
        <el-table-column prop="site" label="项目地址" align="center">
          <template slot-scope="scope">
            <el-form-item :prop="`tableData.${scope.$index}.site`" :rules="rules.site">
              <el-input v-model="scope.row.site" :maxlength="100" placeholder="请填写"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="budget" label="需求预算" align="center">
          <template slot-scope="scope">
            <el-form-item :prop="`tableData.${scope.$index}.budget`" :rules="rules.budget">
              <div class="flex">
                <span>￥</span>
                <el-input
                  v-model="scope.row.budget"
                  placeholder="请填写"
                ></el-input>
              </div>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
      <el-divider content-position="left">需求详情</el-divider>
      <el-form-item prop="content" style="margin-bottom: 10px;">
        <el-input
          v-model="ruleForm.content"
          :rows="3"
          type="textarea"
          :maxlength="500"
          placeholder="请描述您的需求详情，以便服务商准确报价"
        ></el-input>
      </el-form-item>
      <el-form-item prop="name" style="width: 35%">
        <el-upload class="upload-demo" ref="upload"
                   accept=".jpg,.jpeg,.png,.xlsx , .xls ,.docx,.dox,.pdf, .txt,.pptx , .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.XLSX,.XLS ,.DOCX,.DOX ,.TXT , .PPTX"
                   action="/service-center/upload/file/single" :before-upload="fileTypeVerification" :limit="1" :on-exceed="exceedFile"
                   :headers="headers" :file-list="fileList" :on-remove="handleRemove"
                   :on-success="handleAvatarSuccess" :auto-upload="true" :disabled="!$store.state.isLogin">
          <el-button slot="trigger" size="small" type="primary" :disabled="!$store.state.isLogin">上传附件
          </el-button>
        </el-upload>
      </el-form-item>

      <el-divider content-position="left">交易预设</el-divider>
      <div style="margin-left: 60px">
<!--        <div class="flex">
          <el-form-item prop="invoice" label="税务发票" class="width50">
            <el-select v-model="ruleForm.invoice" placeholder="请选择税务发票" :style="{width: `${widthInput}px`}">
              <el-option
                  v-for="item in swfpList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="pay" label="支付方式" class="width50">
            <el-select v-model="ruleForm.pay" placeholder="请选择支付方式" :style="{width: `${widthInput}px`}">
              <el-option
                  v-for="item in zffsList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
              </el-option>
            </el-select>
          </el-form-item>
        </div>-->
        <div class="flex">
          <el-form-item prop="paymentCycle" label="结款周期" class="width50">
            <el-input v-model="ruleForm.paymentCycle" :style="{width: `${widthInput}px`}"></el-input>
          </el-form-item>
          <el-form-item prop="address" label="经营地址" class="width50">
            <el-input v-model="ruleForm.address" :maxlength="250" :style="{width: `${widthInput}px`}"></el-input>
          </el-form-item>
        </div>
          <el-form-item prop="offer" label="报价要求">
            <el-input
            :style="{width: `${widthInput + 400}px`}"
              v-model="ruleForm.offer"
              :rows="3"
              type="textarea"
            :maxlength="500"
              placeholder="请填写您的报价要求"
            ></el-input>
          </el-form-item>
      </div>
      <el-form-item style="text-align: right">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确认询价</el-button
        >
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {addServiceInquiry, getIndexDictionaryData} from "../../../../utils/interface";

export default {
  data() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
      },
      dialogVisible: false,
      widthInput: 310,
      fileList: [],
      ruleForm: {
        tableData: [],
        site: "",
        budget: 0,
        content: "",
      },
      rules: {
        site: [
          { required: true, message: "请填写项目地址", trigger: 'change' },
        ],
        budget: [
          { required: true, message: "请填写需求预算", trigger: 'change' },
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的金额数字，最多两位小数",
            trigger: "blur"
          }
        ],
        content: [
          { required: true, message: "请填写需求详情", trigger: "change" },
        ],
        /*invoice: [
          { required: true, message: "请选择税务发票", trigger: "change" },
        ],
        pay: [
          { required: true, message: "请选择支付方式", trigger: "change" },
        ],*/
        paymentCycle: [
          { required: true, message: "请填写结款周期", trigger: "change" },
        ],
        address: [
          { required: true, message: "请填写经营地址", trigger: "change" },
        ],
        offer: [
          { required: true, message: "请填写报价要求", trigger: "change" },
        ],
      },
      swfpList: [],
      zffsList: [],
      serviceInfo:{},
    };
  },
  methods: {
    init(list) {
      this.ruleForm={};
      this.fileList=[];
      this.ruleForm.tableData=[];
      this.serviceInfo = list;
      this.ruleForm.tableData.push({...list,site:'',budget:''});
      console.log(22222, this.ruleForm.tableData)
      this.dialogVisible = true;
      getIndexDictionaryData({groupCode: "SWFP"}).then((res)=>{
        this.swfpList = res
      })
      getIndexDictionaryData({groupCode: "ZFFS"}).then((res)=>{
        this.zffsList = res
      })
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.ruleForm.accessory = "";
      this.ruleForm.accessoryName = "";
    },
    handleAvatarSuccess(obj, fileList) {
      console.log(obj);
      this.fileList.push(obj);
      this.ruleForm.accessory = obj.url;
      this.ruleForm.accessoryName = obj.name;
    },
    handlePreview(file) {
      console.log(file);
    },
    submitForm(formName) {
      console.log(1111, this.ruleForm)
      console.log(2222, this.tableData)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.serviceId=this.serviceInfo.id
          this.ruleForm.serviceName=this.serviceInfo.title
          this.ruleForm.serviceMoney=this.serviceInfo.money
          this.ruleForm.classifyOne=this.serviceInfo.classifyOne
          this.ruleForm.classifyTwo=this.serviceInfo.classifyTwo
          this.ruleForm.sCreateUser=this.serviceInfo.serviceCreatuser
          this.ruleForm.state="0"
          this.ruleForm.site = this.ruleForm.tableData[0].site;
          this.ruleForm.budget = this.ruleForm.tableData[0].budget;

          addServiceInquiry(this.ruleForm).then((res)=>{
            this.dialogVisible = false;
            console.log(res.message);
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose(){
      this.dialogVisible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    exceedFile(){
      this.$message.warning("只能上传一个附件,请先删除!");
    },
    fileTypeVerification(file) {
      let str = file.name.substring(file.name.indexOf("."));
      if (
          str != ".txt" &&
          str != ".jpg" &&
          str != ".jpeg" &&
          str != ".png" &&
          str != ".xlsx" &&
          str != ".xls" &&
          str != ".docx" &&
          str != ".dox" &&
          str != ".pdf" &&
          str != ".pptx"
      ) {
        return false;
      }
      let fileSize = file.size / 1024 / 1024 < 10;
      if (!fileSize) {
        this.$message.warning('请上传小于10M的文件')
        return false;
      }
    },
  },
};
</script>

  <style lang="less" scoped>
@import "../../style/index.less";
.width50 {
  width: 50%;
}
/deep/.el-dialog__body {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/details/inquire.vue